// The props an open-ended block draws from, ported from the coffee block's calcComponentProps.
//
// One builder per part, composed here. A family that differs in a part replaces that builder and
// keeps the rest - see cx / cn / mn under their own lib/props.

import { getModelValue, isReportVirtual, isReportXpert } from '@aytm/app/stats/lib/stat-page'
import { isVerbatimType as calcIsVerbatimType } from '@aytm/app/stats/page/components/lib/utils'

import { calcChartProps } from '@aytm/app/stats/page/question-views/oe/lib/props/chart'
import { calcChartsModelProps } from '@aytm/app/stats/page/question-views/oe/lib/props/charts-model'
import { calcControlsProps } from '@aytm/app/stats/page/question-views/oe/lib/props/controls'
import { calcTableProps } from '@aytm/app/stats/page/question-views/oe/lib/props/table'
import { calcVerbatimProps } from '@aytm/app/stats/page/question-views/oe/lib/props/verbatim'
import { calcRawData, calcWcProps } from '@aytm/app/stats/page/question-views/oe/lib/props/word-cloud'

export const OE_PROPS_BUILDERS = {
  calcChartProps,
  calcChartsModelProps,
  calcControlsProps,
  calcTableProps,
  calcVerbatimProps,
  calcWcProps,
  calcRawData
}

export const calcComponentProps = (question = {}, builders = OE_PROPS_BUILDERS) => {
  // the verbatim check asks about the question this block hangs off, which for a sub-item is its
  // parent - not the block's own identity
  const isVerbatimType = calcIsVerbatimType({
    ...question,
    questionId: question.parentQuestionId,
    questionType: question.type,
    isReportVirtual: isReportVirtual(),
    isReportXpert: isReportXpert()
  })

  // a caller that already derived the corpus hands it in rather than paying for it twice
  const rawData = question.rawData || builders.calcRawData(question)

  const inputs = { ...question, isVerbatimType, rawData }

  return {
    viewMode: question.viewMode,
    components: question.components,
    answer: question.answer,
    missingTotals: getModelValue('missingTotals') || false,
    controlsProps: builders.calcControlsProps(inputs),
    verbatimProps: builders.calcVerbatimProps(inputs),
    chartsModelProps: builders.calcChartsModelProps(inputs),
    chartProps: builders.calcChartProps(inputs),
    tableProps: builders.calcTableProps(inputs),
    wcProps: builders.calcWcProps(inputs)
  }
}
